import { Injectable } from '@angular/core';
import { 
  HttpInterceptor, 
  HttpRequest, 
  HttpHandler, 
  HttpEvent, 
  HttpHeaders, 
  HttpXsrfTokenExtractor 
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionSotrageService } from './session-sotrage.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  messageValidator = 0;
  constructor(
    private sssotrage: SessionSotrageService, 
    private xsrfExtractor: HttpXsrfTokenExtractor) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = this.xsrfExtractor.getToken() as string;
    
    if (req.body instanceof FormData) {
      const reqClone = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.sssotrage.getCurrentToken(),
          'X-XSRF-TOKEN': token == null ? '' : token
        }
      });

      return next.handle(reqClone);
    }

    // Se mantiene en una línea de momento
    const headers = new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Methods': 'POST,GET,PUT,DELETE',
        'Access-Control-Allow-Headers': 'X-XSRF-Token, Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,Authorization,Access-Control-Allow-Origin,Access-Control-Allow-Methods',
        'Authorization': 'Bearer ' + this.sssotrage.getCurrentToken(),
        'X-XSRF-TOKEN': token == null ? '' : token
      });

    const reqClone = req.clone({
      headers
    });

    this.messageValidator = 1
    //Guardamos el Token en una variable de sesión
    this.sssotrage.setCSRFToken(token);
    return next.handle(reqClone);
  }
}
